export default {
  routers: [
    // 404
    {
      path: "*",
      name: "404",
      component: () => import("@/views/error/NotFound.vue"),
    },
    // 首页
    {
      path: "/",
      name: "index",
      component: () => import("@/views/home/loginView.vue"),
    },
    // 首页
    {
      path: "/indexB",
      name: "indexB",
      component: () => import("@/views/home/loginView.vue"),
    },
    // 登录页
    {
      path: "/tob/login",
      name: "loginB",
      component: () => import("@/views/home/loginView.vue"),
    },
    // C端登录页
    {
      path: "/toc/login",
      name: "loginC",
      component: () => import("@/views/home/loginView.vue"),
    },

    {
      //注册模块
      path: "/toc/Register",
      name: "Register",
      component: () => import("@/views/home/regView.vue"),
    },
    {
      //重置密码
      path: "/toc/ResetPsd",
      name: "ResetPsd",
      component: () => import("@/views/home/resetPsd.vue"),
    },

    // 申请试用
    {
      path: "/try",
      name: "try",
      component: () =>
        import(/* webpackChunkName: "try" */ "@/views/home/TryView.vue"),
    },
    // 关于我们
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "about" */ "@/views/home/AboutView.vue"),
    },
    // 渠道合作
    {
      path: "/cooperation",
      name: "cooperation",
      component: () =>
        import(
          /* webpackChunkName: "cooperation" */ "@/views/home/CooperAtion.vue"
        ),
    },
    // 产品-课程
    {
      path: "/project/course",
      name: "project_course",
      component: () => import("@/views/home/ProjectCourse.vue"),
    },
    // 产品-阿仕图-调查
    {
      path: "/project/live",
      name: "project_live",
      component: () => import("@/views/home/ProjectLive.vue"),
    },
    // 产品-阿仕图-评估
    {
      path: "/project/class",
      name: "project_class",
      component: () => import("@/views/home/ProjectClass.vue"),
    },

    // 控制台
    {
      path: "/control",
      name: "control",
      component: () => import("@/views/manage/indexView.vue"),
    },
    // 培训
    {
      path: "/train",
      name: "train",
      component: () => import("@/views/manage/indexView.vue"),
    },

    // 直播
    // {
    //   path: "/livePlayer",
    //   name: "livePlayer",
    //   component: () => import("@/views/train/live/videoPlayer"),
    // },

    // 会员中心
    {
      path: "/member",
      name: "Member",
      component: () => import("@/views/manage/indexView.vue"),
    },

    // 超管页面
    {
      path: "/admin/",
      name: "admin",
      component: () => import("@/views/admin/routerView.vue"),
    },
  ],
};
